import CorpDataInterchangeConfigStep1 from './CorpDataInterchangeConfigStep1';
export default CorpDataInterchangeConfigStep1;
